import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';
import type { TripStatus } from '@/lib/types';

interface TripStatusBadgeProps {
  status: TripStatus;
  locked?: boolean;
  size?: 'sm' | 'md';
}

const STATUS_STYLES: Record<TripStatus, string> = {
  draft:     'bg-amber-500/10  text-amber-600  border-amber-500/30',
  confirmed: 'bg-blue-500/10   text-blue-600   border-blue-500/30',
  invoiced:  'bg-violet-500/10 text-violet-600 border-violet-500/30',
  paid:      'bg-emerald-500/10 text-emerald-600 border-emerald-500/30',
  disputed:  'bg-orange-500/10 text-orange-600 border-orange-500/30',
  cancelled: 'bg-muted          text-muted-foreground border-border',
};

export function TripStatusBadge({ status, locked, size = 'md' }: TripStatusBadgeProps) {
  const { t } = useTranslation();
  const sizeClass = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5';
  return (
    <span className={`inline-flex items-center gap-1 rounded border font-medium ${sizeClass} ${STATUS_STYLES[status]}`}>
      {t(`trips.status.${status}`)}
      {locked && <Lock className={size === 'sm' ? 'h-2.5 w-2.5' : 'h-3 w-3'} />}
    </span>
  );
}
